import {Backend} from '@common/backend'
import {MessageBox} from '@components/message-box'

export class OpenIdClient {
  static async authenticate(): Promise<void> {
    const res = await Backend.postJSON<{url: string}>(
      '/data/openid/auth-url',
      {}
    )
    if (res.result !== 'ok' || !res.url) {
      MessageBox.show('Failed to sign in with OpenId', 'danger')
    }
    location.href = res.url
  }
}
